import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Page } from "@digital-services/shell";

import SettingsTabMenu from "@account/components/SettingsTabMenu";

const SettingsPage: FC = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "settings" });
  return (
    <Page title={t("page_title")}>
      <div className="pt-8">
        <SettingsTabMenu />
      </div>
    </Page>
  );
};

export default SettingsPage;
